__turbopack_context__.v({
  "h1": "ArtkkelLayout-module__aCvupW__h1",
  "h2": "ArtkkelLayout-module__aCvupW__h2",
  "ingress": "ArtkkelLayout-module__aCvupW__ingress",
  "style": "ArtkkelLayout-module__aCvupW__style",
});
